import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="auto-size, automatic-size, page" maskId="round-filled-radius-0-stroke-1.5-IconAutoSize"><path fillRule="evenodd" clipRule="evenodd" d="M4.75 2C4.33579 2 4 2.33579 4 2.75V21.25C4 21.6642 4.33579 22 4.75 22H19.25C19.6642 22 20 21.6642 20 21.25V2.75C20 2.33579 19.6642 2 19.25 2H4.75ZM5.5 11V3.5H18.5V20.5H13V11.75C13 11.3358 12.6642 11 12.25 11H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoSize;
